import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import dashboardBanner from '../assests/img/dashboard-banner.jpg';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Components/sidebar';

function Exhibitordirectory() {
    const navigate = useNavigate();
    const [customer, setCustomer] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        // Get user credentials from localStorage (set by Login.js)
        const user = localStorage.getItem('user');
        if (!user) {
            setError('No user credentials found. Please login again.');
            setLoading(false);
            navigate('/login');
            return;
        }
        let credentials;
        try {
            credentials = JSON.parse(user);
        } catch (e) {
            setError('Corrupted user credentials. Please login again.');
            setLoading(false);
            localStorage.removeItem('user');
            navigate('/login');
            return;
        }
        if (!credentials.user_id || !credentials.password) {
            setError('Incomplete user credentials. Please login again.');
            setLoading(false);
            localStorage.removeItem('user');
            navigate('/login');
            return;
        }
        fetch(`https://aadikaash.com/backend/wp-json/aadikaash-api/v1/customer_details?user_id=${encodeURIComponent(credentials.user_id)}&password=${encodeURIComponent(credentials.password)}`)
            .then(res => res.json())
            .then(data => {
                setCustomer(data);
                setLoading(false);
            })
            .catch(err => {
                setError('Failed to fetch customer details');
                setLoading(false);
            });
    }, []);

    const handleLogout = () => {
        try {
            localStorage.removeItem('user');
            alert('You have been logged out successfully!');
            // Use setTimeout to ensure navigation after alert
            setTimeout(() => {
                navigate('/login', { replace: true });
            }, 100);
        } catch (error) {
            console.error('Logout failed:', error);
            alert('An error occurred during logout. Please try again.');
        }
    };

    return (
        <div>
            <Header />
            <div className="container dashboard-container">

                  <div className='dashboard-banner'>
                            <img src={dashboardBanner} className='responsive' alt="Dashboard Banner" />
                        </div>
                {/* Debug output for troubleshooting */}
                {error && <pre style={{color:'red'}}>Error: {error}</pre>}
                {!loading && !error && (
                    <details className='d-none' style={{marginBottom:'1em'}}>
                        <summary>Raw API Response (Debug)</summary>
                        <pre>{JSON.stringify(customer, null, 2)}</pre>
                    </details>
                )}
                {loading ? (
                    <div>Loading customer details...</div>
                ) : error ? (
                    <div style={{color: 'red'}}>{error}</div>
                ) : customer && customer.status && customer.data && customer.data.customer_details ? (
                    <>
                        <div className='row'>
                            <div className='welcome-user col-md-12 d-flex justify-content-between align-items-center'>
                                <h1>Welcome {customer.data.customer_details.display_name || 'User'}</h1>
                                <ul>                                  
                                    <li> <button onClick={handleLogout} className="logout-btn btn btn-primary btn-sm">Logout</button></li>
                                </ul>
                            </div>
                        </div>

                      


                        <div className='row'>
                            <div className='col-md-3'>
                                <Sidebar />                                
                            </div>
                            <div className='col-md-9 content-area'>
                                <div className='welcome-page'>
                                    <div className='personal-info-box'>
                                        <h2>Exhibitor Directory</h2>
                                        <p>Content for the Exhibitor Directory page goes here.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
            <Footer />
        </div>
    );
}

export default Exhibitordirectory;
